import type { ModalType, OpenModalParams } from './modal.types';
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  isOpen: false,
  head: null,
  main: null,
  modifier: null,
  payload: null,
  isBottomReached: false,
} satisfies ModalType as ModalType;

const ModalSlice = createSlice({
  name: 'modal',
  initialState,
  reducers: (create) => ({
    openModal: create.reducer<OpenModalParams>((state, action) => {
      state.isOpen = true;
      state.head = action.payload.head;
      state.main = action.payload.main;
      state.payload = action.payload.payload || '';
      state.modifier = action.payload.modifier || '';
    }),
    closeModal: create.reducer((state) => {
      state.isOpen = false;
      state.modifier = null;
      state.payload = null;
      state.isBottomReached = false;
    }),
    clearModalContent: create.reducer((state) => {
      state.head = null;
      state.main = null;
    }),
    clearModalHeader: create.reducer((state) => {
      state.head = null;
    }),
    setIsModalBottomReached: create.reducer<boolean>((state, action) => {
      state.isBottomReached = action.payload;
    }),
  }),
  selectors: {
    modal: (modal) => modal,
    isOpen: (modal) => modal.isOpen,
    head: (modal) => modal.head,
    main: (modal) => modal.main,
    modifier: (modal) => modal.modifier,
    payload: (modal) => modal.payload,
  },
});

export default ModalSlice;
